import { storyblokEditable } from '@storyblok/react/rsc';
import { resolveLink } from '@/lib/helpers';
import FooterColumn from './FooterColumn';
import FooterLocaleSelector from './FooterLocaleSelector';

const SocialIcon = ({ platform }) => {
  switch (platform) {
    case 'Instagram':
      return (
        <svg width="24" height="24" viewBox="0 0 256 256" fill="currentColor">
          <path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160ZM176,24H80A56.06,56.06,0,0,0,24,80v96a56.06,56.06,0,0,0,56,56h96a56.06,56.06,0,0,0,56-56V80A56.06,56.06,0,0,0,176,24Zm40,152a40,40,0,0,1-40,40H80a40,40,0,0,1-40-40V80A40,40,0,0,1,80,40h96a40,40,0,0,1,40,40ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z" />
        </svg>
      );
    case 'Twitter':
      return (
        <svg width="24" height="24" viewBox="0 0 256 256" fill="currentColor">
          <path d="M214.75,211.71l-62.6-98.38,61.77-67.95a8,8,0,0,0-11.84-10.76L143.24,99.34,102.75,35.71A8,8,0,0,0,96,32H48a8,8,0,0,0-6.75,12.3l62.6,98.37-61.77,68a8,8,0,1,0,11.84,10.76l58.84-64.72,40.49,63.63A8,8,0,0,0,160,224h48a8,8,0,0,0,6.75-12.29ZM164.39,208,69.75,59.32A4,4,0,0,1,73.14,53l.47,0H91.61L186.25,196.68A4,4,0,0,1,182.86,203l-.47,0Z" />
        </svg>
      );
    case 'Facebook':
      return (
        <svg width="24" height="24" viewBox="0 0 256 256" fill="currentColor">
          <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm8,191.63V152h24a8,8,0,0,0,0-16H136V112a16,16,0,0,1,16-16h16a8,8,0,0,0,0-16H152a32,32,0,0,0-32,32v24H96a8,8,0,0,0,0,16h24v63.63a88,88,0,1,1,16,0Z" />
        </svg>
      );
    case 'LinkedIn':
      return (
        <svg width="24" height="24" viewBox="0 0 256 256" fill="currentColor">
          <path d="M216,24H40A16,16,0,0,0,24,40V216a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V40A16,16,0,0,0,216,24Zm0,192H40V40H216ZM112,176V124a8,8,0,0,1,16,0v52a8,8,0,0,1-16,0Zm-36-64a12,12,0,1,1,12,12A12,12,0,0,1,76,112Zm-4,64V140a8,8,0,0,1,16,0v36a8,8,0,0,1-16,0Zm84,0V148a20,20,0,0,0-40,0v28a8,8,0,0,1-16,0V124a8,8,0,0,1,15.79-1.78A36,36,0,0,1,176,148v28a8,8,0,0,1-16,0Z" />
        </svg>
      );
    default:
      return <span>{platform}</span>;
  }
};

const Footer = ({ blok, languageLinks }) => {
  const columns = blok.columns || [];
  const socialLinks = blok.social_links || [];
  return (
    <footer className="bg-black text-white px-8 sm:px-16 pt-12 sm:pt-16 pb-6" {...storyblokEditable(blok)}>
      <div className="max-w-container mx-auto">
        {/* Region & Language Selectors */}
        <FooterLocaleSelector languageLinks={languageLinks} />

        {/* Footer Columns */}
        <div className="flex flex-wrap gap-y-8 gap-x-10 lg:gap-x-16 mb-10">
          {columns.map((column) => (
            <FooterColumn blok={column} key={column._uid} />
          ))}
        </div>

        {/* Divider + Copyright + Social */}
        <hr className="border-white/25 mb-6" />
        <div className="flex flex-col-reverse sm:flex-row items-center justify-between gap-4">
          <span className="text-12 text-white/70">
            {blok.copyright || '© Xolo OÜ. All Rights Reserved.'}
          </span>
          <div className="flex items-center gap-4">
            {socialLinks.map((link) => (
              <a
                key={link._uid}
                href={resolveLink(link.url)}
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/70 hover:text-white/50 transition-colors"
                aria-label={`${link.platform} social media link`}
              >
                <SocialIcon platform={link.platform} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
